/**
 * The tags offerable for a job of a given species.
 *
 * A tag with an EMPTY species list applies to EVERYTHING — that is how "all
 * species" is stored (see the `JobTag` model: the absence of a restriction,
 * not a denormalised copy of every species), so it must always be offered.
 *
 * Pure and separate from `useJobTags` so this rule — the one place the
 * empty-means-all convention is acted on in the UI — can be tested directly.
 * @param tags the vendor's enabled tags.
 * @param species the job's species, if known.
 * @returns the tags that may be put on that job.
 */
export function filterTagsForSpecies<T extends { species: readonly string[] }>(
  tags: readonly T[],
  species: string | null | undefined,
): T[] {
  // Structural, not tied to the generated `EnumJobTagSpecies`: this rule is
  // about the shape of the list, and the codegen enum would only make the
  // helper harder to call from a test or a caller holding plain strings.
  return tags.filter(
    (t) => t.species.length === 0 || (!!species && t.species.includes(species)),
  );
}
